<template>
  <b-card>
    <b-card-title>
      <h3>Location</h3>
    </b-card-title>
    <b-row>
      <b-col
        v-if="pickup"
        md="6"
        class="d-flex flex-column"
      >
        <h4>Pick-Up Location</h4>
        <div class="d-flex flex-column">
          <div v-if="pickup.address">
            <span class="font-weight-bold">Address: </span>
            <span>{{ pickup.address }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ pickup.lat }},{{ pickup.lon }}</span>
            <b-button
              v-if="pickup.lat && pickup.lon"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${pickup.lat},${pickup.lon}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col
        v-if="dropoff"
        md="6"
        class="d-flex flex-column"
      >
        <h4>Drop-Off Location</h4>
        <div class="d-flex flex-column">
          <div>
            <span class="font-weight-bold">Address: </span>
            <span>{{ dropoff.address }}</span>
          </div>
          <div>
            <span class="font-weight-bold">lat/lng: </span>
            <span>{{ dropoff.lat }},{{ dropoff.lon }}</span>
            <b-button
              v-if="dropoff.lat && dropoff.lon"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="copyValueToClipboard(`${dropoff.lat},${dropoff.lon}`)"
            >
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BButton,
  },
  props: {
    pickup: {
      type: Object,
      required: true,
    },
    dropoff: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const copyValueToClipboard = val => {
      navigator.clipboard.writeText(val)
      successNotification('Copied to clipboard')
    }

    return {
      copyValueToClipboard,
    }
  },
}
</script>

  <style>

  </style>
